/**
 * @generated SignedSource<<82a70cf11d8817a0472e1827a890b0f7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type videoUpNextWidgetVideo$data = ReadonlyArray<{
  readonly node: {
    readonly entityId?: string;
    readonly " $fragmentSpreads": FragmentRefs<"itemVideoUpNextWidgetItemVideo">;
  };
  readonly " $fragmentType": "videoUpNextWidgetVideo";
}>;
export type videoUpNextWidgetVideo$key = ReadonlyArray<{
  readonly " $data"?: videoUpNextWidgetVideo$data;
  readonly " $fragmentSpreads": FragmentRefs<"videoUpNextWidgetVideo">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "videoUpNextWidgetVideo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "entityId",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "itemVideoUpNextWidgetItemVideo"
            }
          ],
          "type": "Video",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "QueueItemsEdge",
  "abstractKey": null
};

(node as any).hash = "a422a7021330204e83c8d6fa860ca315";

export default node;
